// src/layouts/AuthenticatedLayout.jsx
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from '../components/Sidebar/Sidebar';
import Navbar from '../components/Navbar/Navbar';
import PlanNavbar from '../components/Navbar/PlanNavbar';
import { GetCurrentPlan } from '../services/MyProfileApi';
import { isPlanExpired } from '../utils/planUtils';
import LoadingScreen from '../components/common/LoadingScreen';
import useLoadingStore from '../store/useLoadingStore';
import useOrgStore from '../store/useOrgStore';
import useBootstrapStore from '../store/useBootstrapStore';

export default function AuthenticatedLayout() {
  const location = useLocation();
  const { handleLogout } = useAuth();

  const organization = useOrgStore((state) => state.organization);
  const bootstrapData = useBootstrapStore((state) => state.bootstrapData);

  const hasOrgData =
    Boolean(organization && Object.keys(organization).length > 0) ||
    Boolean(bootstrapData && Object.keys(bootstrapData).length > 0);

  const isSetupCompleted =
    organization?.is_setup_completed ?? bootstrapData?.organization?.is_setup_completed;

  const [planExpired, setPlanExpired] = useState(false);
  const isLoading = useLoadingStore((state) => state.loadingStates[location.pathname] || false);

  const checkPlanStatus = async () => {
    try {
      const res = await GetCurrentPlan();
      const plan = res?.data;

      if (isPlanExpired(plan?.end_date) || plan?.status !== "Active") {
        setPlanExpired(true);
      }
    } catch (err) {
      console.error("Plan check failed", err);
    }
  };

  useEffect(() => {
    if (!location.pathname.includes("/login")) {
      localStorage.setItem("lastVisitedRoute", location.pathname);
    }
  }, [location]);

  useEffect(() => {
    checkPlanStatus();
  }, []);

  if (!hasOrgData) {
    return <LoadingScreen isOpen={true} delay={0} />;
  }

  if (isSetupCompleted === false) {
    return <Navigate to="/home" replace />;
  }
  // const checkPlanStatus = async () => {
  //   try {
  //     const res = await GetCurrentPlan();
  //     const plan = res?.data;
  
  //     //  FORCE POPUP FOR TESTING
  //     const FORCE_EXPIRED = true;
  
  //     if (
  //       FORCE_EXPIRED ||
  //       isPlanExpired(plan?.end_date) ||
  //       plan?.status !== "Active"
  //     ) {
  //       setPlanExpired(true);
  //     }
  //   } catch (err) {
  //     console.error("Plan check failed", err);
  //   }
  // };
  
  return (
    <>
      {/* POPUP */}
      {/* {planExpired && <PlanExpiredPopup onLogout={handleLogout} />} */}

      {/* BLUR WHEN EXPIRED */}
      {/* <div className={`app ${planExpired ? "blurred" : ""}`}> */}
      <div className="app">
        <PlanNavbar />
        <Navbar onLogout={handleLogout} />

        <div className="side-bar-container">
          <Sidebar />
          <div className="main-content" style={{ position: 'relative' }}>
            <LoadingScreen isOpen={isLoading} />
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}